import { z } from "zod";
import type { SnippetVisibility } from "../../lib/types";

export interface SnippetSavePayload {
  name: string;
  body_doc: Record<string, unknown>;
  visibility: SnippetVisibility;
}

export const snippetFormSchema = z.object({
  name: z
    .string()
    .min(1, "Name is required")
    .max(200, "Name must be at most 200 characters"),
  visibility: z.enum(["shared", "private"]),
  body_doc: z.record(z.string(), z.unknown()).refine(
    (doc) => {
      const content = doc.content as Array<Record<string, unknown>> | undefined;
      if (!content || content.length === 0) return false;
      return content.some(
        (node) =>
          node.type !== "paragraph" ||
          (Array.isArray(node.content) && node.content.length > 0),
      );
    },
    { message: "Snippet content is required" },
  ),
});

export type SnippetFormValues = z.infer<typeof snippetFormSchema>;

const EMPTY_DOC: Record<string, unknown> = {
  type: "doc",
  content: [{ type: "paragraph" }],
};

/** Snippet-form defaults. `buildDefaultValues` also exists in the tasks and
 *  presets form schemas: the name is shared feature-form convention, but each
 *  builds its own feature's defaults — nothing to consolidate (ARBI-851). */
export function buildDefaultValues(
  partial?: Partial<SnippetFormValues>,
): SnippetFormValues {
  return {
    name: "",
    visibility: "shared",
    body_doc: EMPTY_DOC,
    ...partial,
  };
}
